export enum CreatedType {
  All = '',
  PartialRepaint = '1',
  PartialColorChange = '2',
  ModelBodyChange = '3',
  ImageInnovation = '5',
  ImageInnovationPlus = '25',
  LineSketchToImage = '6',
  ToLineSketch = '7',
  BgChange = '8',
  DialogGeneration = '20',
  Cutout = '10',
  Enlarge = '11',
  StyleUpperBody = '12',
  FabricUpperBody = '13',
  TaoTu = '22',
}

const createdName: { [key in CreatedType]: string } = {
  [CreatedType.All]: '全部',
  [CreatedType.PartialRepaint]: '自由改款',
  [CreatedType.PartialColorChange]: '服装改色',
  [CreatedType.ModelBodyChange]: '模特变身',
  [CreatedType.ImageInnovationPlus]: '款式创新',
  [CreatedType.LineSketchToImage]: '线稿成款',
  [CreatedType.ToLineSketch]: '线稿生成',
  [CreatedType.Cutout]: '抠图褪底',
  [CreatedType.Enlarge]: '高清放大',
  [CreatedType.DialogGeneration]: '对话生图',
  [CreatedType.BgChange]: '更换背景',
  [CreatedType.StyleUpperBody]: '款式上身',
  [CreatedType.FabricUpperBody]: '面料上身',
  [CreatedType.TaoTu]: '商拍套图',
}

const createdWorkbenchLink: { [key in CreatedType]: string } = {
  [CreatedType.All]: '/plus-fd/workbench',
  [CreatedType.PartialRepaint]: '/plus-fd/workbench/repaint/partial-repaint',
  [CreatedType.PartialColorChange]: '/plus-fd/workbench/repaint/partial-color-change',
  [CreatedType.ModelBodyChange]: '/plus-fd/workbench/photo-assistant/body-change',
  [CreatedType.ImageInnovationPlus]: '/plus-fd/workbench/repaint/innovate',
  [CreatedType.LineSketchToImage]: '/plus-fd/workbench/sketch/line-sketch-to-image',
  [CreatedType.ToLineSketch]: '/plus-fd/workbench/sketch/to-line-sketch',
  [CreatedType.Cutout]: '/plus-fd/workbench/ai-tools/cutout',
  [CreatedType.Enlarge]: '/plus-fd/workbench/ai-tools/enlarge',
  [CreatedType.DialogGeneration]: '/plus-fd/chatting-image',
  [CreatedType.BgChange]: '/plus-fd/workbench/photo-assistant/bg-change',
  [CreatedType.StyleUpperBody]: '/plus-fd/workbench/photo-assistant/style-upper-body',
  [CreatedType.FabricUpperBody]: '/plus-fd/workbench/repaint/fabric-upper-body',
  [CreatedType.TaoTu]: '/plus-fd/workbench/photo-assistant/tao-tu',
}

interface ToolOptions {
  title: string
  subTitle: string
  link: string
  mainUrl: string
  recommendIndex?: number
}

export const toolOptions: ToolOptions[] = [
  {
    title: createdName[CreatedType.StyleUpperBody],
    subTitle: '平铺图改模特图/更换模特',
    link: createdWorkbenchLink[CreatedType.StyleUpperBody],
    mainUrl: 'https://cdn.zhiyitech.cn/material/c916929c300c9eec956af4b7766fcb9f',
    recommendIndex: 5,
  },
  {
    title: createdName[CreatedType.PartialRepaint],
    subTitle: '定向修改服饰局部细节',
    link: createdWorkbenchLink[CreatedType.PartialRepaint],
    mainUrl: 'https://cdn.zhiyitech.cn/material/24a54522ce62996c460952e32b8ea58f',
    recommendIndex: 4,
  },
  {
    title: createdName[CreatedType.ImageInnovationPlus],
    subTitle: '一键生成一套新款款式',
    link: createdWorkbenchLink[CreatedType.ImageInnovationPlus],
    mainUrl: 'https://cdn.zhiyitech.cn/material/b898065bd9e1c52a8eb85ca2f659ebfd',
    recommendIndex: 4,
  },
  {
    title: createdName[CreatedType.DialogGeneration],
    subTitle: '根据您的需求连续对话创作',
    link: createdWorkbenchLink[CreatedType.DialogGeneration],
    mainUrl: 'https://cdn.zhiyitech.cn/material/8632909df5b4c01ebfd12efde32157dd',
    recommendIndex: 4,
  },
  {
    title: createdName[CreatedType.Cutout],
    subTitle: '一键抠图，智能识别画面主体部分',
    link: createdWorkbenchLink[CreatedType.Cutout],
    mainUrl: 'https://cdn.zhiyitech.cn/material/146177d29f72d46e7d2e7f055f07cca6',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.Enlarge],
    subTitle: '一键无损放大图片',
    link: createdWorkbenchLink[CreatedType.Enlarge],
    mainUrl: 'https://cdn.zhiyitech.cn/material/2a00848e02bfbe174c6a2690d5df97f9',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.ToLineSketch],
    subTitle: '一键款式图转线稿图',
    link: createdWorkbenchLink[CreatedType.ToLineSketch],
    mainUrl: 'https://cdn.zhiyitech.cn/material/296ffcd18b5e54864df8eff09af40a27',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.ModelBodyChange],
    subTitle: '保持款式不变，更换模特',
    link: createdWorkbenchLink[CreatedType.ModelBodyChange],
    mainUrl: 'https://cdn.zhiyitech.cn/material/1042ad4c98e4b8051b63be65f24d27f1',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.FabricUpperBody],
    subTitle: '款式不变，更换图案/面料预览效果',
    link: createdWorkbenchLink[CreatedType.FabricUpperBody],
    mainUrl: 'https://cdn.zhiyitech.cn/material/a8d137d985bb49915ff5187d869a10cb',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.TaoTu],
    subTitle: '一键生成套图',
    link: createdWorkbenchLink[CreatedType.TaoTu],
    mainUrl: 'https://cdn.zhiyitech.cn/material/9895f4fe16d50e8e0a5b96858a0e466c',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.PartialColorChange],
    subTitle: '定向修改纯色服饰的颜色',
    link: createdWorkbenchLink[CreatedType.PartialColorChange],
    mainUrl: 'https://cdn.zhiyitech.cn/material/d98e1064389a83ae05748950b87aaa66',
    recommendIndex: 3,
  },
  {
    title: createdName[CreatedType.LineSketchToImage],
    subTitle: '线稿图一键生成成衣图',
    link: createdWorkbenchLink[CreatedType.LineSketchToImage],
    mainUrl: 'https://cdn.zhiyitech.cn/material/0e927248240ef3a43c4df901169c15c5',
    recommendIndex: 3,
  },
]
